var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmongUsWatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.94,
    height: 33.47,
    x: 6.03,
    y: 3,
    fill: "#2ea9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,37.47H6a1,1,0,0,1-1-1V3A1,1,0,0,1,6,2H58a1,1,0,0,1,1,1V36.47A1,1,0,0,1,58,37.47ZM7,35.47H57V4H7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 38,
    y: 25,
    fill: "#bfbfbf",
    rx: 3.25,
    ry: 3.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.75,34h-1.5A4.26,4.26,0,0,1,37,29.75v-1.5A4.26,4.26,0,0,1,41.25,24h1.5A4.26,4.26,0,0,1,47,28.25v1.5A4.26,4.26,0,0,1,42.75,34Zm-1.5-8A2.25,2.25,0,0,0,39,28.25v1.5A2.25,2.25,0,0,0,41.25,32h1.5A2.25,2.25,0,0,0,45,29.75v-1.5A2.25,2.25,0,0,0,42.75,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,37.47H6a1,1,0,0,1-1-1V3A1,1,0,0,1,6,2H58a1,1,0,0,1,1,1V36.47A1,1,0,0,1,58,37.47ZM7,35.47H57V4H7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b90005",
    d: "M43.39,29.68V58.15A2.85,2.85,0,0,1,40.54,61H39.12a2.85,2.85,0,0,1-2.85-2.85h0A4.27,4.27,0,0,0,32,53.88h0a4.27,4.27,0,0,0-4.27,4.27h0A2.85,2.85,0,0,1,24.88,61H23.46a2.85,2.85,0,0,1-2.85-2.85v-28a11.69,11.69,0,0,1,10.57-11.8A11.4,11.4,0,0,1,43.39,29.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.24,
    height: 12.81,
    x: 24.88,
    y: 33.95,
    fill: "#b90005",
    rx: 2.42,
    ry: 2.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.54,62H39.12a3.86,3.86,0,0,1-3.85-3.85,3.27,3.27,0,0,0-6.54,0A3.86,3.86,0,0,1,24.88,62H23.46a3.86,3.86,0,0,1-3.85-3.85v-28a12.65,12.65,0,0,1,11.5-12.79A12.4,12.4,0,0,1,44.39,29.68V58.15A3.86,3.86,0,0,1,40.54,62ZM32,52.88a5.28,5.28,0,0,1,5.27,5.27A1.85,1.85,0,0,0,39.12,60h1.42a1.85,1.85,0,0,0,1.85-1.85V29.68A10.39,10.39,0,0,0,31.25,19.32a10.66,10.66,0,0,0-9.64,10.8v28A1.85,1.85,0,0,0,23.46,60h1.42a1.85,1.85,0,0,0,1.85-1.85A5.28,5.28,0,0,1,32,52.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7,47.76H27.3a3.42,3.42,0,0,1-3.42-3.41v-8A3.42,3.42,0,0,1,27.3,33h9.4a3.42,3.42,0,0,1,3.42,3.42v8A3.42,3.42,0,0,1,36.7,47.76ZM27.3,35a1.43,1.43,0,0,0-1.42,1.42v8a1.42,1.42,0,0,0,1.42,1.41h9.4a1.42,1.42,0,0,0,1.42-1.41v-8A1.43,1.43,0,0,0,36.7,35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.77,
    height: 4.62,
    x: 6.03,
    y: 8.19,
    fill: "#b90005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8,13.81H6a1,1,0,0,1-1-1V8.19a1,1,0,0,1,1-1H11.8a1,1,0,0,1,1,1v4.62A1,1,0,0,1,11.8,13.81ZM7,11.81H10.8V9.19H7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.77,
    height: 4.62,
    x: 6.03,
    y: 17.43,
    fill: "#270073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8,23H6a1,1,0,0,1-1-1V17.43a1,1,0,0,1,1-1H11.8a1,1,0,0,1,1,1V22A1,1,0,0,1,11.8,23ZM7,21H10.8V18.43H7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.77,
    height: 4.62,
    x: 6.03,
    y: 26.66,
    fill: "#c0a800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8,32.28H6a1,1,0,0,1-1-1V26.66a1,1,0,0,1,1-1H11.8a1,1,0,0,1,1,1v4.62A1,1,0,0,1,11.8,32.28ZM7,30.28H10.8V27.66H7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.77,
    height: 4.62,
    x: 52.2,
    y: 8.19,
    fill: "#c0a800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,13.81H52.2a1,1,0,0,1-1-1V8.19a1,1,0,0,1,1-1H58a1,1,0,0,1,1,1v4.62A1,1,0,0,1,58,13.81Zm-4.77-2H57V9.19H53.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.77,
    height: 4.62,
    x: 52.2,
    y: 17.43,
    fill: "#270073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,23H52.2a1,1,0,0,1-1-1V17.43a1,1,0,0,1,1-1H58a1,1,0,0,1,1,1V22A1,1,0,0,1,58,23ZM53.2,21H57V18.43H53.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.77,
    height: 4.62,
    x: 52.2,
    y: 26.66,
    fill: "#b90005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,32.28H52.2a1,1,0,0,1-1-1V26.66a1,1,0,0,1,1-1H58a1,1,0,0,1,1,1v4.62A1,1,0,0,1,58,32.28Zm-4.77-2H57V27.66H53.2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmongUsWatch);
export default __webpack_public_path__ + "static/media/among-us-watch.5fc4ee74f034a7ac689604d33708d00a.svg";
export { ForwardRef as ReactComponent };